<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="left">
        <div class="link-box">
          <a
            class="service-link link"
            href="javascript:;"
            @click="openServiceLink"
            >{{ letter.fwtk }}</a
          >
          <a
            class="policy-link link"
            href="javascript:;"
            @click="openPrivacyLink"
            >{{ letter.yszc }}</a
          >
          <a
            v-if="paypricyLink && paypricy"
            href="javascript:;"
            @click="openPaypricyLink"
            class="policy-link link"
            >{{ paypricy }}</a
          >
        </div>
        <p class="copyright" v-html="copyright"></p>
      </div>
      <div class="right">
        <safe-footer></safe-footer>
      </div>
    </div>
  </footer>
</template>

<script>
import SafeFooter from '@components/officialTopup/SafeFooter.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGameLanguage } from '@store/languages/gameConf';
import serviceLink from '@mixins/officialTopup/serviceLink';
import { getCopyright } from '@utiles/reviewFooter';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'pageFooter',
  mixins: [serviceLink],
  data() {
    let copyright = `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.08.23 邓智轩：送审域名+对应游戏+带参数p=rupay时替换copyright
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id') ||
      globalConfig.getHrefParam('gameID') ||
      '';
    return {
      copyright: getCopyright(gameId) || copyright
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    paypricyLink() {
      return getGameLanguage('', 'paypricyLink', this.gameId);
    },
    paypricy() {
      return getGameLanguage('', 'paypricy', this.gameId);
    },
    gameId() {
      return this.$store.state.gameId;
    }
  },
  methods: {
    openPaypricyLink() {
      this.openLink(this.paypricyLink);
    }
  },
  components: {
    SafeFooter
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';
.footer {
  background-color: $moduleBackgroundColor;
  color: #333333;
  position: relative;
  width: 100%;
  padding: 0 40px 40px;
  box-sizing: border-box;
  .footer-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
    background-color: $backgroundColor;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 0 20px 40px;

    .left {
      margin: 10px 0;
      .copyright {
        text-align: center;
        font-size: 20px;
        line-height: 1.5;
      }

      .link-box {
        text-align: center;
        position: relative;
        margin-bottom: 30px;
      }

      .link {
        margin-right: 20px;
        display: inline-block;
        font-size: 20px;
        color: #333333;
        text-decoration: none;
        cursor: pointer;
      }

      .link + .link {
        &::before {
          content: '|';
          margin-right: 20px;
        }
      }
    }
    .right {
    }
  }
}

@media screen and (orientation: landscape) {
  .footer {
    background-color: #111111;
    color: #f6f6f6;
    position: relative;
    width: 100%;
    padding: 28px 0 30px 0;
    box-sizing: border-box;
    .footer-container {
      background-color: #111111;
      margin: 0 auto;
      max-width: 1200px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: baseline;
      padding: 0;

      .left {
        margin: 10px 0;
        .copyright {
          text-align: start;
          font-size: 18px;
          line-height: 1.5;
        }

        .link-box {
          text-align: start;
          margin-bottom: 40px;
        }

        .link {
          margin-right: 20px;
          display: inline-block;
          font-size: 18px;
          color: #f6f6f6;
          text-decoration: none;
          cursor: pointer;
        }

        .link + .link {
          &::before {
            content: '|';
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>
